import { render, staticRenderFns } from "./quality_inspector.vue?vue&type=template&id=dea5df70"
import script from "./quality_inspector.vue?vue&type=script&lang=js"
export * from "./quality_inspector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports